import { useEffect, useState } from 'react';

const KEY = 'est_cookie_ack';

export default function CookieBanner() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    try {
      if (localStorage.getItem(KEY) !== '1') setShow(true);
    } catch {
      setShow(true);
    }
  }, []);

  function ack() {
    try {
      localStorage.setItem(KEY, '1');
    } catch {
      /* localStorage unavailable; banner just stays dismissed for this session */
    }
    setShow(false);
  }

  if (!show) return null;

  return (
    <div className="cookie-banner" role="region" aria-label="Cookie notice">
      <p className="cookie-banner-text">
        I use one essential cookie (<code>est_session</code>) to keep
        you signed in. No analytics, no tracking, no third-party scripts.
      </p>
      <button type="button" className="cookie-banner-btn" onClick={ack}>
        Got it
      </button>
    </div>
  );
}
